import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_3: R2BReferralBrandEntity = {
  token: "r2b_referral_3",
  type: "r2bReferralBrand",
  name: "Coastal Breeze Decor",
  email: "stehr.albin@example.com",
  website: "stylezone.org",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
